import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <h3>Start exploring the endless possibilities.</h3>
    </div>
    <div className="gpt3__cta-btn">
    </div>
  </div>
);

export default CTA;
